import HandoffMetricOption from './HandoffMetricOption';

export default HandoffMetricOption;

export type { IHandoffMetricOptionProps } from './HandoffMetricOption';
